/* MGC product videos (2026-10-18, updated 2026-11-04).
   Product page: the gallery no longer jumps to the video and autoplays it (Sami, Nov 2026).
   The video stays in its normal gallery position, and the "Watch the video" button (snippets/mgc-video-popup.liquid)
   opens a video popup instead.
   Collection / homepage cards (desktop with a mouse only): hovering a card for a moment plays the product's
   video muted over the image. Video URL comes from /products/<handle>.js, fetched only on hover. */
!function () {
  if (window.MGC_VIDEO) return; window.MGC_VIDEO = 1;

  /* ---------- card hover (desktop only) ---------- */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cache = {};
  function hOf(u) { var m = String(u || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }
  function videoUrl(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      var m = p && (p.media || []).filter(function (x) { return x.media_type === 'video'; })[0];
      if (!m) return null;
      var s = (m.sources || []).filter(function (x) { return x.format === 'mp4' || /mp4/.test(x.mime_type || ''); })
        .sort(function (a, b) { return Math.abs((a.height || 0) - 480) - Math.abs((b.height || 0) - 480); })[0];
      return s ? s.url : null;
    }).catch(function () { return null; });
    return cache[handle];
  }
  function bind(box, handle) {
    if (box.dataset.mgcv) return; box.dataset.mgcv = 1;
    var t, vid;
    box.addEventListener('mouseenter', function () {
      t = setTimeout(function () {
        videoUrl(handle).then(function (u) {
          if (!u || !box.matches(':hover')) return;
          if (!vid) {
            vid = document.createElement('video');
            vid.className = 'mgc-cv'; vid.muted = true; vid.loop = true; vid.playsInline = true; vid.preload = 'auto';
            vid.setAttribute('muted', ''); vid.setAttribute('playsinline', ''); vid.src = u;
            if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
            box.appendChild(vid);
          }
          vid.classList.add('on'); var p = vid.play(); if (p && p.catch) p.catch(function () {});
        });
      }, 250);
    });
    box.addEventListener('mouseleave', function () { clearTimeout(t); if (vid) { vid.classList.remove('on'); vid.pause(); } });
  }
  function cards() {
    if (!canHover) return;
    document.querySelectorAll('product-block:not([data-mgcvb])').forEach(function (p) {
      p.setAttribute('data-mgcvb', 1);
      var a = p.querySelector('a[href*="/products/"]'), h = a && hOf(a.getAttribute('href')), box = p.querySelector('.image-cont');
      if (h && box) bind(box, h);
    });
    document.querySelectorAll('a.mgc-card:not([data-mgcvb])').forEach(function (a) {
      a.setAttribute('data-mgcvb', 1);
      var h = hOf(a.getAttribute('href')), box = a.querySelector('.mgc-ph');
      if (h && box) bind(box, h);
    });
  }

  var st = document.createElement('style');
  st.textContent = '.mgc-cv{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:3;opacity:0;transition:opacity .25s;pointer-events:none;background:#000}.mgc-cv.on{opacity:1}';
  document.head.appendChild(st);

  function run() {
    cards();
    var q; new MutationObserver(function () { clearTimeout(q); q = setTimeout(cards, 300); }).observe(document.body, { childList: true, subtree: true });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
}();
